import {Log as LogBase} from '@aboutyou/mlm';
import {useIsDataInfoMonitoringConsentGiven} from '@aboutyou/storage';
import {useCallback} from 'react';
import {useLogInstanceId} from './useLogInstanceId';

export const useExpressCheckoutFlowLogger = () => {
  const {id: logInstanceId} = useLogInstanceId();
  const isConsented = useIsDataInfoMonitoringConsentGiven();

  const Log = useCallback(
    ({
      event,
      attributes = {},
    }: {
      event:
        | 'exp-co-click'
        | 'exp-co-popup-continue'
        | 'exp-co-popup-cancel'
        | 'exp-co-widget-entry';
      attributes?: Record<string, unknown>;
    }) => {
      if (!isConsented) {
        return;
      }
      LogBase.unSampledLog(event, {
        feature: 'exp-co-flow',
        event,
        log_instance_id: logInstanceId,
        device: `${process.env.STACK}-web`,
        ...attributes,
      });
    },
    [isConsented, logInstanceId],
  );

  return {
    Log,
  };
};
